// extracted by mini-css-extract-plugin
export default {"page":"JournalPage_page__4Gc+m","loaderWrap":"JournalPage_loaderWrap__Bv4Xl","empty":"JournalPage_empty__0XszB"};